import {defineStore} from 'pinia'
import {usePageContentDataStore} from "@/stores/pageContentData"
import {useItemDataStore} from "@/stores/itemData"

export const usePagePathStore = defineStore('pagePath', {
    state: () => ({
        suffix: '',
        pageContentId: null,
    }),
    
    actions: {
        async get({pageId}) {
            /* todo - Add support for page content IDs
            if (this.pageContentId) {
                let pageId = usePageContentDataStore().items.filter((obj) => {
                    return obj.id === this.pageContentId
                })[0].pageId
      
                return this.getPath({ pageId })
                    .then((path) => {
                        return path + '#' + this.pageContentId
                    });
            }
            //*/
            
            return this.getPath({pageId})
        },
        
        async getPath({pageId}) {
            const itemDataStore = useItemDataStore()
            let path = '/'
            
            if (this.suffix) {
                path += '#' + this.suffix
            }
            
            const obj = await itemDataStore.get({
                tableName: 'pages',
                id: pageId,
            })
            
            path = '/' + obj.url + path
            
            return this.loadParent({
                parent: obj.parent,
                path: path,
            })
        },
        
        async loadParent({parent, path}) {
            if (parent && parent !== '0') {
                const itemDataStore = useItemDataStore()
                
                const obj = await itemDataStore.get({
                    tableName: 'pages',
                    id: parent,
                })
                
                path = '/' + obj.url + path
                
                return this.loadParent({
                    parent: obj.parent,
                    path: path,
                })
            }
            
            return path
        },
    },
})